import { render, staticRenderFns } from "./PageEdit.vue?vue&type=template&id=5883c7e8"
import script from "./PageEdit.vue?vue&type=script&lang=js"
export * from "./PageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports